<template>
  <div
    class="bg-cDarkBlue px-6 py-8 text-white xl:py-12 xl:px-40 leading-normal"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div class="md:col-span-2 md:flex md:mx-4 lg:col-span-1 lg:grid">
        <img
          src="../assets/logo-footer.webp"
          alt=""
          class="w-6/12 mx-auto md:w-4/12 lg:w-6/12 lg:ml-3 lg:mt-4 xl:w-5/12"
        />
        <p
          class="text-center my-6 text-sm leading-normal tracking-wide md:text-left md:ml-10 md:text-base lg:ml-3 lg:-mr-4 xl:mr-0"
        >
          Sedekah Kuy adalah sebuah komunitas yang bergerak di bidang sosial
          sekaligus wadah penyalur donasi dari para donatur baik dalam internal
          group maupun eksternal yang menjunjung tinggi nilai keikhlasan.
        </p>
      </div>
      <div
        class="text-center md:text-left md:ml-10 md:mt-6 lg:mt-28 lg:ml-20 xl:mt-24 xl:ml-16"
      >
        <h5 class="text-sm font-semibold tracking-widest mb-3 xl:text-base">
          QUICK LINKS
        </h5>
        <ul class="text-sm">
          <li>
            <router-link
              to="#tentang"
              class="flex justify-center md:justify-start my-2"
              ><img src="../assets/arrow.svg" alt="#tentang" /> Sedekah
              Kuy</router-link
            >
          </li>
          <li>
            <router-link
              to="#visi-misi"
              class="flex justify-center md:justify-start my-2"
              ><img src="../assets/arrow.svg" alt="#visi-misi" /> Visi & Misi
              SeKuy</router-link
            >
          </li>
          <li>
            <router-link
              to="#program-sekuy"
              class="flex justify-center md:justify-start my-2"
            >
              <img src="../assets/arrow.svg" alt="#program-sekuy" />Program
              SeKuy</router-link
            >
          </li>
          <li>
            <router-link
              to="#sedekah-kuy"
              class="flex justify-center md:justify-start my-2"
            >
              <img src="../assets/arrow.svg" alt="#sedekah-kuy" />Mau Sedekah di
              SeKuy</router-link
            >
          </li>
          <li>
            <router-link
              to="#donasi"
              class="flex justify-center md:justify-start my-2"
            >
              <img src="../assets/arrow.svg" alt="#donasi" />Donasi</router-link
            >
          </li>
        </ul>
      </div>
      <div
        class="mt-6 text-center md:text-left lg:mt-28 lg:ml-14 xl:mt-24 xl:ml-8"
      >
        <h5 class="text-sm font-semibold tracking-widest mb-3 xl:text-base">
          INFO SEDEKAH KUY
        </h5>
        <div class="flex justify-center my-6">
          <div class="flex-initial">
            <img src="../assets/cursor.svg" alt="" />
          </div>
          <div class="flex-initial">
            <p class="text-sm ml-3 xl:mr-8">
              Jl. H. Asdi Gang Gigi, Gebang Raya Periuk Tangerang
            </p>
          </div>
        </div>
        <div class="flex justify-center md:justify-start my-6">
          <div class="flex-initial">
            <img src="../assets/telp.svg" alt="" />
          </div>
          <div class="flex-initial">
            <a href="https://wa.me/6285895906742" target="_blank">
              <p class="text-sm ml-3 tracking-wider">0858-9590-6742</p></a
            >
          </div>
        </div>
        <div class="flex justify-center md:justify-start my-6">
          <div class="flex-initial">
            <img src="../assets/envelope.svg" alt="" />
          </div>
          <div class="flex-initial">
            <a href="mailto:sedekahkuypeduli@gmail.com" target="_blank"
              ><p class="text-sm pl-3 tracking-widest">
                sedekahkuypeduli@gmail.com
              </p></a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="flex mt-8 justify-center md:justify-start md:ml-8 md:mt-10">
      <div class="flex-initial">
        <img src="../assets/ig.svg" alt="" />
      </div>
      <div class="flex-initial">
        <a href="https://www.instagram.com/sekuy_peduli/" target="_blank">
          <p class="ml-3">@sekuy_peduli</p></a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>